<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'EmailCellRenderer',
    methods: {
        getValue () {
            const { value } = this.params
            return value
        },
    },
    render (h) {
        const { value } = this.params
        return h(
            'div',
            {
                class: 'EmailCellRenderer',
            },
            [
                h('a', {
                    attrs: {
                        href: `mailto:${value}`,
                        target: '_blank',
                    },
                }, value),
            ],
        )
    },
})
</script>
<style scoped lang="scss">
.EmailCellRenderer {
    span + span {
        margin-left: 8px;
    }
}
</style>
